import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../../data/blogsData';
import './Blogs.css';

const BlogList: React.FC = () => {
  useEffect(() => {
    document.title = 'Blogs | ASW Cars & Finance';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Explore informative commercial vehicle guides, financing tips, loan documentation checklists, and vehicle comparisons by ASW Cars & Finance.'
      );
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-page-wrapper">
      <div className="blogs-container" style={{ paddingTop: '40px' }}>
        {/* Clean Page Title Header */}
        <div className="blogs-page-header">
          <h1>Blogs</h1>
          <div className="blogs-header-divider"></div>
        </div>

        {/* All Blog Cards Grid (No Images) */}
        <div className="blogs-grid">
          {BLOG_POSTS.map((post) => (
            <Link to={`/blogs/${post.slug}`} key={post.id} className="blog-card blog-card-no-img">
              <div className="blog-card-body">
                <div className="blog-meta-row">
                  <span className="blog-category-badge">{post.category}</span>
                  <span>•</span>
                  <span>
                    <i className="fa fa-clock-o"></i> {post.readTime}
                  </span>
                  <span>•</span>
                  <span>{post.publishDate}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.summary}</p>
                <div className="blog-card-footer">
                  <div className="blog-author-info">
                    <div className="author-avatar">{post.author.charAt(0)}</div>
                    <span className="author-name">{post.author}</span>
                  </div>
                  <span className="read-more-btn">
                    Read Article <i className="fa fa-arrow-right"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Consultation Call to Action Banner */}
        <div className="blogs-consult-banner">
          <div className="consult-text">
            <h3>Need Help Choosing the Right Commercial Car or Loan?</h3>
            <p>
              ASW Cars & Finance has over 11+ years of experience helping commercial drivers, taxi owners, and business fleets in Maharashtra with transparent pricing and low down-payment finance.
            </p>
          </div>
          <div className="consult-actions">
            <a href="tel:+919987828690" className="btn-consult-call">
              <i className="fa fa-phone"></i> Call +91 99878 28690
            </a>
            <a
              href="https://wa.me/919987828417?text=Hi%20ASW%20Cars,%20I%20am%20interested%20in%20commercial%20vehicle%20finance%20and%20offers."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-consult-wa"
            >
              <i className="fa fa-whatsapp"></i> WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
